module.exports = __webpack_public_path__ + "img/mobile_mypage.082a8ab.png";